import { render, staticRenderFns } from "./set-shop.vue?vue&type=template&id=60df72b6&scoped=true"
import script from "./set-shop.vue?vue&type=script&lang=js"
export * from "./set-shop.vue?vue&type=script&lang=js"
import style0 from "./set-shop.vue?vue&type=style&index=0&id=60df72b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60df72b6",
  null
  
)

export default component.exports